<script>
    import axios from '../../../util/service';
    import { mapActions } from 'vuex';
    import { NOTIFICATION_OVERLAY } from '../../../constants/overlay-id';
    import { readCookie, writeCookie } from '../../../util/dom/cookie';



    export default {
        methods: {
            ...mapActions('vue-ui/overlay', ['openOverlay', 'closeOverlay']),
            onPopupPayloadReady({ data }) {
                if (data.state === false || readCookie(NOTIFICATION_OVERLAY)) {
                    return;
                }

                const date = new Date();
                // let this cookie expire tomorrow
                date.setDate(date.getDate() + 1);

                writeCookie({
                    key: NOTIFICATION_OVERLAY,
                    value: '1',
                    path: '/',
                    expires: date,
                });

                this.openOverlay({
                    id: NOTIFICATION_OVERLAY,
                    component: 'dyn-overlay-dialog',
                    transition: 'trs-simple-fade',
                    props: {
                        onAccept: () => this.closeOverlay({ id: NOTIFICATION_OVERLAY }),
                        ...data,
                    },
                });
            },
        },
        mounted() {
            axios.get(`/${ globals.config.currentLanguage }/api/popup`).then(this.onPopupPayloadReady);
        },
        render() {
            return null;
        },
    };
</script>
